"use strict";
var error_message_display_component_1 = require("./error-message-display.component");
exports.ErrorMessageDisplayComponent = error_message_display_component_1.ErrorMessageDisplayComponent;
var error_message_display_module_1 = require("./error-message-display.module");
exports.BhtpErrorMessageDisplayModule = error_message_display_module_1.BhtpErrorMessageDisplayModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/error-message-display/index.js